import moment from "moment-timezone";
import { graphqlApiCall } from "./graphql.service";
import { AddSubscriptionObj, fetchWrapper } from "src/helpers";

const baseUrl = "/api/subscription_admin";
const updateBaseUrl = "/api/subscription_admin/update";

type User = {
  userId: string;
  name: string;
  email: string;
  mobileNumber: string;
};

type Subscription = {
  platform: string;
  currentPeriodEnd: string;
  status: string;
  name: string;
  userByUserId: User;
};

type FormattedSubscription = {
  user_id: string;
  name: string;
  email: string;
  mobile_number: string;
  subscription_name: string;
  subscription_status: string;
  subscription_end_date: string;
  subscription_platform: string;
};

const getAll = async (): Promise<FormattedSubscription[]> => {
  const columns = [
    "userByUserId { userId name email mobileNumber }",
    "name",
    "status",
    "currentPeriodEnd",
    "platform",
  ];

  const response = (await graphqlApiCall({
    node: "allUserSubscriptions",
    columns,
    conditions: "orderBy: CURRENT_PERIOD_END_DESC",
  })) as Subscription[];

  if (!response || !Array.isArray(response)) return [];

  return response.map((sub) => ({
    user_id: sub.userByUserId.userId,
    name: sub.userByUserId.name,
    email: sub.userByUserId.email,
    mobile_number: sub.userByUserId.mobileNumber,
    subscription_name: sub.name,
    subscription_status: sub.status,
    subscription_end_date: moment
      .unix(Number(sub.currentPeriodEnd || 0))
      .format("DD/MM/YYYY"),
    subscription_platform: sub.platform,
  }));
};

const create = async (params: AddSubscriptionObj) => {
  await fetchWrapper.post(
    baseUrl,
    params as unknown as Record<string, unknown>,
  );
};

const update = async (body: AddSubscriptionObj) => {
  return await fetchWrapper.put(
    updateBaseUrl,
    body as unknown as Record<string, unknown>,
  );
};

export const subscriptionsService = {
  getAll,
  create,
  update,
};
